import en from './dictionaries/app/en.json';
import pt from './dictionaries/app/pt.json';

export default async i18next => {
  await i18next.addResourceBundle('en', 'app', en, true, true);
  await i18next.addResourceBundle('pt', 'app', pt, true, true);
};
